import { useState } from "react";
import { FormField, Input, SpaceBetween, Box } from "@cloudscape-design/components";
import { useNotification } from "contexts/NotificationContext";
import SubmitButton from "styles/SubmitButton";
import { useUserContext } from "contexts/UserContext";

export default function ProfileTab() {
    const {addNotification} = useNotification();
    const {firstName , lastName , email , updateUserProfile} = useUserContext();
    const [newFirstName, setNewFirstName] = useState(firstName || "");
    const [newLastName, setNewLastName] = useState(lastName || "");
    const [isUpdating, setIsUpdating] = useState(false);
    
    

    const updateProfile = async () => {    
        setIsUpdating(true);
        try {
            await updateUserProfile(newFirstName.trim() , newLastName.trim()); // calls the context function
            addNotification('success', 'Profile updated successfully!');
        } catch (error) {
            addNotification('error', 'Failed to update profile');
        } finally {
            setIsUpdating(false);
        }
    };

    return (
        <SpaceBetween size="l">
            <FormField label="Username / Email" constraintText="Username is the same as email">
                <Input value={email || ''} disabled />
            </FormField>
            <FormField label="First name">
                <Input
                    value={newFirstName}
                    onChange={({ detail }) => setNewFirstName(detail.value)}
                />
            </FormField>
            <FormField label="Last name">
                <Input
                    value={newLastName}
                    onChange={({ detail }) => setNewLastName(detail.value)}
                />
            </FormField>
            <Box textAlign="right">
                <div className="update-button">
                    <SubmitButton
                        variant="primary"
                        onClick={updateProfile}
                        disabled={isUpdating}
                    >
                        {isUpdating ? 'Updating...' : 'Update profile'}
                    </SubmitButton>
                </div>
            </Box>
        </SpaceBetween>
    );
}
